import { useQuery } from 'react-query'
import { shouldRetry } from '../../shared/retry'
import type { AvatarBoClient } from '../../shared/types'

export const publishKeys = {
  versions: (channel: string) => ['avatar-bo', 'versions', channel] as const,
}

export interface UseVersionsOpts {
  client: AvatarBoClient
  channel?: string
  enabled?: boolean
}

/**
 * The versions list. Lives in the feature layer because BOTH the publish panel and the catalogue's
 * draft banner read it, and a widget must not import another widget to get at it.
 */
export function useVersions({
  client,
  channel = 'prod',
  enabled = true,
}: UseVersionsOpts) {
  return useQuery(
    publishKeys.versions(channel),
    () => client.listVersions(channel),
    { enabled, refetchOnWindowFocus: false, retry: shouldRetry },
  )
}
